export const gutterWidth = 32;

const grid = {
  gutterWidth
};

export default grid;
